// eslint-disable-next-line import/prefer-default-export
export { StyledCoverMaxWidth } from './styles';
export { StyledCoverMaxWidthPadding } from './styles';
export { StyledCoverCenter } from './styles';
export { maxWidthWideStyle } from './styles';
export { maxWidthStyle } from './styles';
export { sectionSpacing } from './styles';
